'use client';

import { useLottie } from 'lottie-react';
import lottie from '../../assets/lotties-data/cjrLoader.json';
const LandingPageLoaderLottie = () => {
  const options = {
    animationData: lottie,
    loop: true,
    style: {
      height: '200px',
      width: '200px',
    },
  };

  const { View } = useLottie(options);
  return View;
};

export default LandingPageLoaderLottie;
